<template>
  <el-select
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    remote
    clearable
    :filterable="filterable"
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    @visible-change="$event ? remoteMethod() : null"
    :loading="loading"
  >
    <el-option
      v-for="item in options"
      :key="item"
      :label="item"
      :value="item"
    >
    </el-option>
  </el-select>

</template>

<script>


import {paginator} from "@/mixins/paginator";
import requestSender from "@/api/base/requestSender";

export default {
  name: "LevelCardUserSubdivisionSelect",
  mixins: [],
  components: {},
  props: {
    value: {},
    size: {type: String, default: ''},
    placeholder: {type: String, default: ''},
    multiple: {type: Boolean, default: false},
    filterable: {type: Boolean, default: false},

    subdivisionLevel: {type: Number, required: true},
    filters: {type: Object, required: true},
  },

  data() {
    return {
      loading: false,
      query: null,
      options: [],
    }
  },
  mounted() {},
  watch: {
    value(newValue){
      this.localValue = newValue;
    }
  },
  computed: {
    localValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.selected(newValue)
      }
    }
  },
  methods: {
    remoteMethod(query) {
      this.query = query;
      this.options = [];
      this.getData();
    },


    getData() {
      this.loading = true;
      requestSender('get', 'card-users-search/search-subdivision', {
        ...this.filters,
        subdivision_search: this.query,
        subdivision_level: this.subdivisionLevel,
      })
        .then(data => {
          this.options = data.subdivisions;
        })
        .finally(() => {
          this.loading = false;
        })
    },

    selected(value) {
      this.$emit('input', value);
      this.$emit('selected', value)
    }
  },

}
</script>


<style scoped>

</style>